import React, { useEffect } from 'react';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import './contact.css';
import Languages from './Languages';
export default function Contact() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  return (
    <>
      <Navbar />

      <div className="container">
        {/* ===== Header Section ===== */}
        <section className="header-section">
          <h1>Contact Us</h1>
          <p>We’re Here to Help You Connect with Ancient Wisdom!</p>
        </section>

        {/* ===== Hyderabad Office ===== */}
        <section className="contact-info-section">
          <h2>Hyderabad Office</h2>
          <p className="contact-info">
            <i className="fas fa-map-marker-alt" style={{ color: '#ff8c00' }}></i>
            &nbsp; LIG-B, Plot No: 204, Dr. AS Rao Nagar Rd, beside SUB POST OFFICE,<br />
            Anupuram Colony, A.S. Rao Nagar, Hyderabad, Secunderabad,<br />
            Telangana – 500062.
          </p>
          <p className="contact-info">
            <i className="fas fa-phone" style={{ color: '#ff8c00' }}></i>
            &nbsp; Phone: <a href="tel:+917402167580" className="phone-link">+91 74021 67580</a>
          </p>
          <p className="contact-info">
            Our team is available Monday to Saturday, from 9 AM to 7 PM.<br />
            Feel free to call or visit for guidance, appointments, or consultations.
          </p>
        </section>

        {/* ===== Vaitheeswaran Kovil Office ===== */}
        <section className="contact-info-section">
          <h2>Vaitheeswaran Kovil Office</h2>
          <p className="contact-info">
            <i className="fas fa-map-marker-alt" style={{ color: '#ff8c00' }}></i>
            &nbsp; No.17B, Therku Veedhi,<br />
            Mayiladuthurai Main Road,<br />
            Vaitheeswaran Kovil,<br />
            Mayiladuthurai District,<br />
            Tamil Nadu – 609117.
          </p>
          <p className="contact-info">
            <i className="fas fa-phone" style={{ color: '#ff8c00' }}></i>
            &nbsp; Phone: <a href="tel:+917402167580" className="phone-link">+91 74021 67580</a>
          </p>
        </section>

        {/* ===== Map Section ===== */}
        <section className="map-section">
          <h2>Our Hyderabad Location</h2>
          <iframe
            title="Hyderabad Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.917639619938!2d78.551817!3d17.480328!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb99351d957431%3A0x8b0ccf5bc455d61!2sLIG-B%2C%20Plot%20No%3A%20204%2C%20Dr.%20AS%20Rao%20Nagar%20Rd%2C%20beside%20SUB%20POST%20OFFICE%2C%20Anupuram%20Colony%2C%20A.%20S.%20Rao%20Nagar%2C%20Hyderabad%2C%20Secunderabad%2C%20Telangana%20500062!5e0!3m2!1sen!2sin!4v1730960735029!5m2!1sen!2sin"
            width="100%"
            height="200"
            style={{ border: 0, borderRadius: '8px' }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>

          <h2 style={{ marginTop: '2rem' }}>Our Vaitheeswaran Kovil Location</h2>
          <iframe
            title="Vaitheeswaran Kovil Location"
            src="https://www.google.com/maps?q=Vaitheeswaran+Kovil,+Mayiladuthurai,+Tamil+Nadu+609117&output=embed"
            width="100%"
            height="200"
            style={{ border: 0, borderRadius: '8px' }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </section>
      </div>

      <Footer />
    </>
  );
}
